<template>
  <h1><span class="text-primary">תנאי השימוש</span> באתר {{ $domain }}</h1>
  <p class="mb-5"><strong>תקנון השימוש באתר הנ"ל נכתב בלשון זכר אך האמור בו מתייחס לנשים וגברים כאחד.</strong></p>
  <AppThirdLayout>
    <h2>קדימון</h2>
    <div>
      <p class="mb-2">
        אתר "{{ SITE_NAME }}",
        <AppLink :to="hostUrl">{{ $domain }}</AppLink>
        (להלן "האתר") הוא אתר המופעל ע"י חברת eVisanet Ltd (להלן "המפעיל") ומשמש
        כשירות הנפקת ויזה אלקטרונית ואישורי ויזה למדינות שונות, והנך מוזמן לקחת בו
        חלק בכפוף להסכמתך לתנאי השימוש אשר יפורטו להלן. אם אינך מסכים לתקנון האתר
        – כולו או חלקו – אינך רשאי לעשות שימוש באתר זה לכל מטרה שהיא.
      </p>
      <p class="mb-2">
        בנוסף, השימוש באתר זה על כל תכניו והשירותים המוצעים בו, הורדות של קבצים,
        מדיה כגון תמונות וסרטונים והתכנים השונים המוצעים לקהל המבקרים עשויים
        להשתנות מעת לעת או בהתאם לסוג התוכן.
      </p>
      <p>
        הנהלת האתר שומרת לעצמה את הזכות לעדכן את תנאי השימוש המוצגים להלן מעת לעת
        וללא התראה או אזכור מיוחד בערוצי האתר השונים.
      </p>
    </div>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>קניין רוחני</h2>
    <div>
      <p class="mb-2">
        האתר כמו גם כל המידע שבו לרבות עיצוב האתר, קוד האתר, קבצי מדיה לרבות
        גרפיקות, סרטונים, תמונות, טקסטים, קבצים המוצעים להורדה וכל חומר אחר אשר
        מוצג באתר שייכים במלואם לאתר הנ"ל ומהווים קניין רוחני בלעדי של אתר "{{SITE_NAME}}"
        ואין לעשות בהם שימוש ללא אישור כתוב מראש מאתר "{{ SITE_NAME }}".
      </p>
      <p>
        בנוסף אין להפיץ, להעתיק, לשכפל, לפרסם, לחקות או לעבד פיסות קוד, גרפיקות,
        סרטונים, סימנים מסחריים או כל מדיה ותוכן אחר מבלי שיש ברשותכם אישור כתוב
        מצוות האתר מראש.
      </p>
    </div>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>תוכן האתר</h2>
    <div>
      <p class="mb-2">
        אנו שואפים לספק לכם את המידע המוצג באתר ללא הפרעות אך יתכנו בשל שיקולים
        טכניים, תקלות צד ג או אחרים, הפרעות בזמינות האתר. ולכן איננו יכולים
        להתחייב כי האתר יהיה זמין לכם בכל עת ולא יינתן כל פיצוי כספי או אחר בשל
        הפסקת השירות / הורדת האתר.
      </p>
      <p class="mb-2">
        קישורים לאתרים חיצוניים אינם מהווים ערובה כי מדובר באתרים בטוחים, איכותיים
        או אמינים וביקור בהם נעשה על דעתכם האישית בלבד ונמצאים בתחום האחריות
        הבלעדי של המשתמש באתר.
      </p>
      <p>
        התכנים המוצעים באתר הינם בבעלותה הבלעדית של "{{ SITE_NAME }}" ואין לעשות
        בהם שימוש אשר נוגד את האמור בתקנון זה למעט במקרים בהם צוין אחרת או במקרים
        בהם צוין כי זכויות היוצרים שייכים לגוף חיצוני. במקרים אלו יש לבדוק מהם
        תנאי השימוש בקישור המצורף ולפעול על פי המצוין באתר החיצוני לו שייכים
        התכנים.
      </p>
    </div>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>ניהול משתמשים ומבקרים באתר</h2>
    <div>
      <p class="mb-2">
        הנהלת האתר שומרת לעצמה את הזכות לחסום כל משתמש ובין אם על ידי חסימת כתובת
        הIP של המחשב שלו, כתובת הMACID של המחשב שלו או אפילו בהתאם למדינת המוצא
        ללא צורך לספק תירוץ אשר מקובל על הגולש.
      </p>
      <p class="mb-2">
        הנהלת האתר / צוות האתר יעשה כל שביכולתו להגן על פרטי המשתמשים באתר ו/או
        לקוחות האתר. במקרים בהם יעלה בידיו של צד שלישי להשיג גישה למידע, לרבות
        פרטי דרכון, מוסכם בזאת כי לגולשים, לקוחות ומשתמשים באתר לא תהיה כל תביעה,
        טענה או דרישה כלפי המפעיל ו/או צוות האתר "{{ SITE_NAME }}".
      </p>
      <p class="mb-2">הזנת פרטי האשראי מהווה את אישורך לשימוש בכרטיס לצורך תשלום על השירות.</p>
      <p>
        המפעיל אינו מתחייב לשמירתו וגיבויו של המידע המוזן באתר ולא יישא באחריות
        בגין אובדן מידע.
      </p>
    </div>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>גילוי נאות</h2>
    <p>
      באתר זה עלול להיעשות שימוש בקבצי קוקיז (במיוחד עבור משתמשים רשומים
      ומנויים) ובממשקי סטטיסטיקה פנימיים כדי לשמור תיעוד סטטיסטי אנונימי של
      גולשים וניתוח תנועת הגולש/ים, הרגלי גלישה באתר וניתוח קליקים וזמן שהייה.
      בכל העת ולבד מאשר גולשים המחוברים לאתר המידע הנשמר הוא אנונימי לחלוטין
      ואין בו את שם הגולש או כל פרט מזהה אחר.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>שימוש ראוי</h2>
    <p>
      עליך לציית לכל מדיניות והנחיה המוצגת באתר ובעמוד בו הנך משתמש. אתה מתחייב
      שלא לעשות שימוש שאינו כשורה באתר - למשל להשתמש בעזרים חיצוניים ובמתודות
      שאינם חלק מן הממשק של האתר. אתה רשאי להשתמש באתר אך ורק על-פי המותר בחוק,
      ועל-פי ההנחיות שאנו מספקים באתר. כל חריגה עלולה להוביל לסירוב מתן שירות
      מצד צוות האתר. יצוין שהמידע אשר הינך מזין באתר יעובד ויישלח למשרד הממשלתי
      הרלוונטי עבור הנפקת הויזה, על-כן מתן מידע כוזב באתר מהווה עבירה פלילית וכן
      כל הצהרה שקרית או מטעה עלולה להוביל לשלילת הבקשה לוויזה ו/או מניעת כניסה
      למדינות לצמיתות.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>תיאור השירות</h2>
    <p>
      האתר מציע שירות הוצאת ויזה למדינות שונות עבור תשלום. זהו השירות הבלעדי
      והיחידי אותו מציעים האתר וצוות האתר.אתה מבין היטב שצוות האתר אינו לוקח כל
      אחריות על תזמון הנפקת ושליחת הויזה ללקוח. קבלת הויזה מוקדם או מאוחר מתאריך
      כזה או אחר, אינה מהווה עילה להחזרים כספיים או לתביעה - שכן השירות עוסק
      בהנפקת ויזה בלבד. ללא כל חובת התחשבות בלוח הזמנים של הלקוח.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>זכות סירוב למתן שירות</h2>
    <p>
      האתר וצוות האתר שומרים לעצמם את הזכות לבחור לאילו לקוחות להעניק שירות,
      ולאילו לא. האתר וצוות האתר רשאים לא לתת שירות לכל אדם. כל זאת ללא צורך
      לנמק את סיבת הסירוב כלל.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>אחריות שימוש</h2>
    <div>
      <p class="mb-2">
        בכל מקרה של תקלה, ו/או דחיית בקשה להנפקת ויזה, ו/או דחיית בקשה להנפקת
        אישור לקבלת אשרה, ו/או מניעת כניסה למדינה מסוימת - בין אם זמנית ובין אם
        לצמיתות - אינה באחריות האתר וצוות האתר. הנך מבין את ההשלכות הכרוכות בשימוש
        בשירותי האתר ומסכים לשאת באחריות מלאה בכל מקרה כמצוין לעיל ולא תהא לך כל
        טרוניה וטענה כלפי המפעיל וצוות האתר. המפעיל יהא פטור מכל אחריות למקרים של
        שיבושים ו/או אי דיוקים ו/או טעויות הקלדה ו/או שגיאות דפוס במסגרת הזנת
        הפרטים ע"י המשתמש באתר ו/או מסירת הפרטים לנציג האתר. המשתמש מנוע מלטעון
        כנגד בעל האתר בגין נזקים והפסדים שייתכן ויגרמו בשל שיבושים וטעויות כאמור.
      </p>
      <p class="mb-2">בעשותך שימוש באתר הנך מתחייב כי לא תעשה אחד או יותר מהדברים הבאים:</p>
      <ol>
        <li>
          התחזות לאדם או גוף כלשהו, לרבות נציג, עובד או מנהל של החברה ו/או מסירת
          תיאור מסולף או הצגה כוזבת של קשר בינך ובין צד שלישי.
        </li>
        <li>
          הטענה, שליחה או שידור של כל חומר שקרי ומטעה או חומר אשר נועד להערים על
          אדם או על גוף כלשהו, במישרין ו/או בעקיפין.
        </li>
        <li>
          הטענה, שליחה או שידור של כל חומר המכיל כל סוג של וירוס מחשב או כל קוד
          מחשב אחר, המתוכנן להרוס, להפריע, או להגביל את השימוש (ובכלל זה כל שימוש
          אחר מלבד שימוש הוגן וסביר בשירות) בכל אחד מן המחשבים, השרתים, החומרה
          ו/או התוכנה אשר מצויים בשימוש החברה לצורך אספקת השירותים המוצעים באתר
          זה.
        </li>
        <li>הפצת "דואר זבל" (spam) לשרתי האתר, או הצפתם בכל דואר אחר.</li>
        <li>
          שינוי, עיבוד, העתקה, שאיבת מידע, התאמה, מתן רישיון משנה, תרגום, מכירה,
          ביצוע פעולות של הנדסה חוזרת, פירוק או הרכבה מחדש של כל אחד מחלקי הקוד
          המרכיבים את האתר, לרבות בסיס המידע, וכן פעולות כאלה לגבי החומרה והתוכנה
          אשר מצויות בשימוש עבור השירות.
        </li>
        <li>
          הצבת האתר, או כל חלק ממנו, בתוך מסגרת של אתר אחר ,(frame) או כחלק מאתר
          אחר ,(mirror) ללא הסכמה בכתב ומראש של החברה.
        </li>
        <li>
          שימוש בכל "רובוט", "תולעת" ,(spider) מנוע אחזור וחיפוש מידע, או בכל כלי
          אוטומטי או ידני אחר אשר מתוכנן לאנדקס, לאחזר, ולאתר מידע באתר או כלי
          כאמור אשר מתוכנן לחשוף את מבנה מאגר הנתונים והקוד באתר זה.
        </li>
        <li>
          הפרעה בכל דרך אחרת, או קטיעה של האתר (לרבות על ידי הפרעה לפעולות השרת
          ורשת המחשבים המחוברים לאתר או של רשת המחשבים המחוברת אליה) או הפרה באופן
          כזה או אחר של הדרישות והפרוצדורות של האתר.
        </li>
        <li>שימוש שנועד להתחקות אחר אדם אחר או להטריד אדם אחר בכל דרך שהיא.</li>
        <li>
          איסוף או אגירת מידע אישי על משתמשים אחרים לשם מטרות כלכליות או בלתי
          חוקיות. כמו כן מכירה, הפצה או כל שימוש כלכלי במידע באתר או כל שימוש אחר
          באופן העלול לפגוע באדם אשר המידע רלוונטי לו.
        </li>
      </ol>
    </div>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>הרשאת עיבוד תמלילי ותרגום</h2>
    <p>
      אתה מבין ומסכים לכך שכחלק ממאמצי צוות האתר לספק שירות מהיר ונוח ללקוחותיו,
      מידע המוזן בטפסי האתר יתורגם ו/או יעובד תמלילית, כראות-עיניו של צוות האתר.
      התרגום והעיבוד נעשים על-מנת להתאים את בקשת הלקוחות באתר אל הדרישות של
      המשרדים השונים אשר באמצעותם צוות האתר מנפיק אשרות כניסה. אתה מאשר ונותן
      לצוות האתר יד חופשית בתרגום ועיבוד התכנים שהינך מזין באתר.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>משך טיפול</h2>
    <p>
      הצהרות באתר הנוגעות למשך הזמן מרגע השימוש בשירותיו עד להנפקת ויזה ושליחתה
      ללקוח, אינן אלא הערכות מושכלות של צוות האתר עקב ניסיון מוקדם במתן שירות
      זה. אין לראות בהצהרות אלו התחייבות כלשהי למהירות או לזמני השלמת השירות,
      שכן מדובר בגורמים שאינם בשליטת האתר וצוות האתר - כדוגמת התנהלות רשויות
      הגירה ומשרדי חוץ של ממשלות זרות, חגים, עומסים תקופתיים וכדומה. אתה מודע
      ומסכים לכך שמשך השירות עד להשלמתו עלולה להתקצר ולהתארך בעקבות גורמים
      צפויים ובלתי-צפויים כאחד.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>אמצעי התקשרות</h2>
    <p>
      כל ההתנהלות של האתר וצוות האתר מול הלקוח נעשית באמצעות דואר אלקטרוני
      (דוא"ל, מייל). אתה מבין ומודע לכך שכל ניסיון ליצור איתך קשר, בין אם עבור
      שליחת אשרה ובין אם עבור כל סיבה אחרת, תיעשה באמצעות הודעת דוא"ל שתישלח
      לכתובת הדוא"ל שהוזנה בטופס ששלחת דרך אתרנו. צוות האתר עלול לשלוח, בין
      היתר, הערות והתראות בכל הנוגע לפרטים שהזנת בטפסי האתר. אתה מבין שהחובה
      לבדוק בתכיפות מספקת את תיבת כתובת הדוא"ל שהזנת באתר לעדכונים, הודעות
      ודרישות מהאתר ומצוות האתר מוטלת עליך והינה באחריותך בלבד. האמור נכון גם
      לגבי הודעות שהועברו לתיבת הספאם (Spam), מסיבה כלשהי. צוות האתר אינו לוקח
      אחריות בכל מקרה של אי ידיעה מצדך על הודעות שנשלחו - גם במקרים בהם צוות
      האתר עצר את הטיפול בבקשתך, עד למענה הולם מצדך באמצעות דוא"ל.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>אימות פרטי אשרה</h2>
    <p>
      אתה מודע לכך ומבין שאחריות אימות נכונות המידע שנשלח ממך אל האתר, ואחריות
      אימות נכונות המידע שנשלח מצוות האתר אליך - מוטלת עליך בלבד. אתה מבין
      שמחובתך לבדוק את נכונות הפרטים (לרבות שמות, מספרי דרכון, תאריכים, הוראות
      פעולה וכיוצא באלה) מרגע שהאשרה - או כל הודעה אחרת מהאתר או מצוות האתר -
      מגיעה אל תיבת הדוא"ל שלך. אתה מבין שמחובתך לבדוק בתכיפות מספקת את תיבת
      הדוא"ל שלך, בין היתר על-מנת להיות ערוך לתרחיש בלתי צפוי, כגון שגיאה בפרטי
      האשרה. בהינתן מצב כגון שגיאה בפרטי אשרה - בין אם זו נגרמה ע"י מערכת האתר
      או צוות האתר, ובין אם נגרמה על-ידך או ע"י כל גורם צד שלישי - מחובתך
      הבלעדית לדווח באופן מיידי לצוות האתר בהודעת דוא"ל. האתר וצוות האתר לא
      נושאים באחריות על כל הפסד כספי ו/או עגמת נפש שנגרמים בעקבות דיווח מאוחר
      (דהיינו, אחרי נקודה בזמן בה התאפשר תיקון וטיפול מקדים בבעיה) או אי-דיווח
      על שגיאה באשרה ו/או בהודעה שנשלחה ממערכת האתר.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>מידע באתר</h2>
    <p>
      אתה מבין היטב שהמידע אשר מוצג באתר ומידע הניתן מצוות האתר, אינו מגיע מגורם
      רשמי. אתה מודע לכך שהמידע הניתן מטעם האתר והצוות, בכל הנוגע לנושאים שאינם
      קשורים ישירות לאישור הויזה (כגון טיסות, נהלי נמלים, חברות תעופה, אכיפה,
      חוקים וכו') הינו בגדר המלצה בלבד, וייתכן שאינו נכון או כדאי. לא תהא לך שום
      טענה אם יתברר שהמידע המוצג באתר והניתן ע"י צוות האתר, אינו מדויק ו/או אינו
      נכון. כל המידע שמסופק ע"י האתר והצוות מיועד אך ורק לעזור ללקוחות החברה,
      כמיטב הידיעה של הצוות. אין בכך כל ערבות לנכונות הפרטים והמידע.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>מדיניות ביטולים</h2>
    <p>
      בעת שליחת טופס באחד מעמודי האתר, מערכות האתר פועלות באופן אוטומטי ומיידי
      על-מנת לתת מענה מהיר ללקוחות האתר. פעולות אלו כרוכות, בין היתר, בתשלום
      אגרות ויזה לרשויות הגירה ממשלתיות וגורמים רלוונטיים נוספים המסייעים לצוות
      האתר להנפיק אשרות כניסה. מרגע שליחת טופס כלשהו באתר ותשלום, אין החזרים
      כספיים בגין ביטול ההזמנה. צוות האתר רשאי לסרב לכל דרישה של החזר כספי בגין
      ביטול הזמנה, בכל נסיבה שהיא, וזאת בהתאם לסעיף 14ג2 בחוק הגנת הצרכן
      הישראלי, "ביטול עסקת מכר מרחוק למתן שירותי תיירות מחוץ לישראל".
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>החזרים כספיים</h2>
    <p>
      כחלק משירות הנפקת אשרה אלקטרונית, צוות האתר מציע החזר כספי מלא במקרים בהם
      בקשתך להוצאת ויזה נדחתה, או אם הנפקת הויזה ושליחתה אליך התעכבו מעל למתוכנן
      ביותר מ-7 ימי עסקים, באשמת מערכת האתר.אולם ישנם סייגים אשר מבטלים החזר
      כספי זה, ופוטרים את האתר וצוות האתר מהתחייבות זו: כל דחיית בקשה לאשרה או
      דחיית אישור ויזה שהסיבה לה טמונה בפרטים שגויים ו/או בלתי-מדויקים ו/או
      בלתי-עדכניים ו/או חסרים שהזנת באחד מטפסי האתר, או שסיפקת לצוות האתר באחת
      או יותר מכל דרכי ההתקשרות המוצעות לך באתר. האמור נכון גם לפרטים אשר סופקו
      לצוות האתר באיחור, במצבים בהם רשויות ההגירה דורשות מידע נוסף עבור הנפקת
      הויזה ומקציבות זמן מקסימלי לקבלת תשובה. סייגים נוספים הפוטרים את האתר
      מהחזר כספי עקב דחייה כוללים דחייה בעקבות כח עליון (Force Majeure) הנמצא
      מחוץ לשליטתנו, לדוגמה מזג האוויר קיצוני המבטל טיסות או מגפה עולמית כמו
      וירוס הקורונה אשר גורמת לסגירת גבולות. בנוסף במידה והגשת בעבר בקשה דומה
      לאותה המדינה, והבקשה נדחתה, או לחלופין מצב בו הבקשה אושרה והויזה עדיין
      תקפה. כל שימוש באתר שעובר על אחד או יותר מהתנאים המפורטים בעמוד זה ישלול
      את זכות המשתמש לקבלת החזר כספי.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>פיצויים</h2>
    <p>
      אתה מודע ומבין היטב שהאתר וצוות האתר מעניקים שירותי הוצאת ויזה בלבד.
      דהיינו, המוצר הסופי עליו הלקוח משלם, ושאותו הוא מקבל, זה אישור ויזה למדינה
      ספציפית, ותו לא. על כן, אין החברה מחויבת בפיצוי אשר סכומו עולה על המחיר
      ששילמת עבור שירות האתר. החברה לא לוקחת אחריות כספית על פעולות שביצעת
      בעקבות השימוש בשירות שמציע האתר - כגון הזמנת טיסה, מקומות לינה, שינויי
      הזמנה וכו'. בנוסף, החברה אינה מחויבת לפצות על עגמת נפש, אפילו אם נגרמה ע"י
      התנהלות קלוקלת של צוות האתר.החברה וצוות האתר לא ייקחו כל אחריות במצב בו
      גורם ממשלתי אוסר עליך או על כל לקוח אחר להיכנס למדינה כלשהי. בין אם זמנית
      ובין אם לצמיתות. האמור נכון גם לגבי מצבים בהם גורם ממשלתי מטיל עליך או על
      כל לקוח אחר איסור ו/או מניעת הנפקה של ויזות למדינה כלשהי - באופן זמני ו/או
      לצמיתות.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>שיפוי</h2>
    <p>
      הנך מתחייב לשפות את המפעיל, או מי מטעמו, בגין כל תביעה, דרישה, נזק, הפסד,
      אובדן רווח, תשלום או כל הוצאה שייגרמו להם – ובכלל זה שכר טרחת עורך דין
      (סביר) והוצאות משפט – עקב הפרת תקנון זה ו/או הפרת החוק על ידו ו/או תביעה
      ו/או דרישת צד שלישי כלשהו ו/או כל הפרה של תנאי מתקנון האתר.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>איזור שיפוט</h2>
    <p>
      בעת שאתם עושים שימוש באתר ובמקרה בו התגלעה כל מחולקת אתם מסכימים להלן כי
      האמור לעיל נמצא תחת סמכות השיפוט הבלעדי של החוק האנגלי תוך שימוש במערכת
      בתי המשפט האנגליים בלבד במחוז לונדון, אנגליה. מחובתך כמקבל שירות שהוא תושב
      או אזרח של מדינה זרה או שהוא נמצא באותה העת במדינה זרה, לבחון ולבדוק האם
      השירות ותנאי השימוש בשירות תואמים גם את חוקי המדינה הזרה. אין ביכולתה של
      החברה להתאים את השירות ותנאי השימוש בשירות לחוקים של כל מדינה ומדינה
      בעולם. אי לכך, מובהר, כי אתה תישא לבדך באחריות על כל הפרת דין של מדינה זרה
      באם תתבצע כתוצאה משימוש בשירות.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>שינויים בתנאי השימוש</h2>
    <p>
      תנאי השימוש באתר עלולים להשתנות בכל עת, וללא כל התראה, בהתאם לרצון של צוות
      האתר. מערכת האתר וצוות האתר אינם מחויבים להודיע על שינויים מכל סוג בתנאי
      השימוש.
    </p>
  </AppThirdLayout>
  <AppThirdLayout>
    <h2>מדיניות פרטיות</h2>
    <p>
      באמצעות שימוש באתר {{ SITE_NAME }}, אתם מסכימים
      <AppLink to="/privacy">למדיניות הפרטיות של האתר</AppLink>.
    </p>
  </AppThirdLayout>
</template>

<script setup lang="ts">
import { SITE_NAME } from "~/assets/constants";
const { hostUrl } = useRouting();
</script>